import { Component } from '@angular/core';
import { LoginComponent } from './LoginComponent/login.component';
import { HomeComponent } from './HomeComponent/home.component';
import { AuthGuard, AuthenticationService } from './auth/index';
import { Environment } from './app/../../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {  

  constructor(
    private authGuard: AuthGuard, 
    private authService: AuthenticationService) { }

    ngOnInit() : void {
    }

    logOut() : void {
        this.authService.logout();
    }
}
